import { render, staticRenderFns } from "./EditRecipients.vue?vue&type=template&id=7d4b724e&scoped=true&"
import script from "./EditRecipients.vue?vue&type=script&lang=js&"
export * from "./EditRecipients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4b724e",
  null
  
)

export default component.exports